import { HeaderLink } from 'src/components/ZillowNavbar/page-frame-types/HeaderLink';
import { ColumnatedLinkList, FlatLinkList } from 'src/components/ZillowNavbar/page-frame-types/HeaderSubSection';

export const isColumnatedLinkList = (
    links: FlatLinkList<HeaderLink> | ColumnatedLinkList<HeaderLink>
): links is ColumnatedLinkList<HeaderLink> => Array.isArray(links[0]);
